import * as Vue from "vue";
import * as Vuex from "vuex";
import * as VueRouter from "vue-router";
import Axios from "axios";

(<any>window).Vue = Vue;
(<any>window).Vuex = Vuex;
(<any>window).VueRouter = VueRouter;
(<any>window).Axios = Axios;